const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    // FARM_DASHBOARD: '/farm-dashboard',
    ADMIN: '/admin',
    DEBUG: '/debug',
    MAP: '/OperationMap'
}

export default ROUTES;